<div class="booking-container">
  <div class="booking-content" *ngIf="!verified">
    <div class="verification-card">
      <div class="verification-icon">
        <lucide-icon name="mail" [size]="32"></lucide-icon>
      </div>
      <h3 class="verification-title">Email Verification Required</h3>
      <p class="verification-text">
        Please verify your email address to book a court and enjoy our services.
      </p>
    </div>
  </div>

  <div class="booking-content" *ngIf="verified">
    <div class="loading-overlay" *ngIf="loading">
      <div class="loading-spinner"></div>
      <p class="loading-text">Loading courts...</p>
    </div>

    <div class="approval-notice" *ngIf="!vipForSelectedClub && selectedClub">
      <span class="notice-icon"
        ><lucide-icon name="clock" [size]="16"></lucide-icon
      ></span>
      <span class="notice-text"
        >Your reservation will require club approval</span
      >
    </div>

    <div class="vip-notice" *ngIf="vipForSelectedClub && selectedClub">
      <span class="notice-icon"
        ><lucide-icon name="star" [size]="16"></lucide-icon
      ></span>
      <span class="notice-text">VIP Member - Instant approval</span>
    </div>

    <div class="filter-section">
      <h3 class="section-title">Court Type</h3>
      <div class="filter-tabs">
        <button
          class="filter-tab"
          [class.active]="filterType === 'all'"
          (click)="setFilterType('all')"
        >
          <span class="tab-icon"
            ><lucide-icon name="landmark" [size]="16"></lucide-icon
          ></span>
          <span class="tab-text">All</span>
        </button>
        <button
          class="filter-tab"
          [class.active]="filterType === 'indoor'"
          (click)="setFilterType('indoor')"
        >
          <span class="tab-icon"
            ><lucide-icon name="home" [size]="16"></lucide-icon
          ></span>
          <span class="tab-text">Indoor</span>
        </button>
        <button
          class="filter-tab"
          [class.active]="filterType === 'outdoor'"
          (click)="setFilterType('outdoor')"
        >
          <span class="tab-icon"
            ><lucide-icon name="sun" [size]="16"></lucide-icon
          ></span>
          <span class="tab-text">Outdoor</span>
        </button>
      </div>
    </div>

    <div class="clubs-section">
      <h3 class="section-title">Select Club</h3>
      <div class="clubs-grid">
        <div
          *ngFor="let club of filteredClubs"
          class="club-card"
          [class.selected]="selectedClub && selectedClub.id === club.id"
          (click)="selectClub(club)"
        >
          <div class="club-image">
            <img
              [src]="club.img_path"
              [alt]="club.name"
              (error)="handleImageError($event)"
              [style.display]="
                club.img_path && !club.imageError ? 'block' : 'none'
              "
            />
            <div
              class="club-placeholder"
              *ngIf="!club.img_path || club.imageError"
            >
              <div class="placeholder-icon">
                <lucide-icon name="landmark" [size]="32"></lucide-icon>
              </div>
              <div class="placeholder-text">Image Coming Soon</div>
            </div>
            <div class="club-overlay">
              <div class="club-name">{{ club.name }}</div>
            </div>
          </div>
          <div class="club-info">
            <div class="club-details">
              <div class="detail-item">
                <span class="detail-icon"
                  ><lucide-icon name="map-pin" [size]="14"></lucide-icon
                ></span>
                <span class="detail-text">{{ club.location }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-icon"
                  ><lucide-icon name="circle-dot" [size]="14"></lucide-icon
                ></span>
                <span class="detail-text"
                  >{{ club.number_of_courts }} courts</span
                >
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="booking-details" *ngIf="selectedClub" #clubDetails>
      <div class="selected-club-card" (click)="openClubInfo()">
        <div class="club-header">
          <div class="club-image-small">
            <img [src]="selectedClub.img_path" [alt]="selectedClub.name" />
          </div>
          <div class="club-info-header">
            <h4 class="club-name">{{ selectedClub.name }}</h4>
            <div
              class="club-location"
              (click)="
                openMaps(selectedClub.location); $event.stopPropagation()
              "
              title="Click to open in Google Maps"
            >
              <span class="location-icon"
                ><lucide-icon name="map-pin" [size]="14"></lucide-icon
              ></span>
              <span class="location-text">{{ selectedClub.location }}</span>
              <span class="maps-hint"
                ><lucide-icon name="smartphone" [size]="12"></lucide-icon
              ></span>
            </div>
          </div>
          <button class="info-button" type="button">
            <span class="info-icon"
              ><lucide-icon name="info" [size]="16"></lucide-icon
            ></span>
          </button>
        </div>

        <div class="club-stats">
          <div class="stat-item">
            <span class="stat-icon"
              ><lucide-icon name="clock" [size]="16"></lucide-icon
            ></span>
            <div class="stat-content">
              <span class="stat-label">Hours Today</span>
              <span class="stat-value">{{ clubWorkingHoursDisplay }}</span>
            </div>
          </div>
          <div class="stat-item">
            <span class="stat-icon"
              ><lucide-icon name="hash" [size]="16"></lucide-icon
            ></span>
            <div class="stat-content">
              <span class="stat-label">From</span>
              <span class="stat-value">{{ clubMinPrice }} RSD/h</span>
            </div>
          </div>
          <div class="stat-item">
            <span class="stat-icon"
              ><lucide-icon name="circle-dot" [size]="16"></lucide-icon
            ></span>
            <div class="stat-content">
              <span class="stat-label">Courts</span>
              <span class="stat-value">{{
                selectedClub.number_of_courts
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="match-settings">
        <div class="setting-group">
          <h4 class="setting-title">Match Type</h4>
          <div class="match-type-selector">
            <button
              *ngFor="let option of availableMatchTypeOptions"
              class="match-type-btn"
              [class.active]="matchType === option.value"
              [disabled]="option.disabled"
              (click)="matchType = option.value; onMatchTypeChange()"
            >
              <span class="type-icon"
                ><lucide-icon
                  [name]="option.value === 'single' ? 'user' : 'users'"
                  [size]="16"
                ></lucide-icon
              ></span>
              <span class="type-text">{{ option.label }}</span>
            </button>
          </div>
        </div>

        <div class="setting-group">
          <div class="private-toggle">
            <div class="toggle-info">
              <span class="toggle-icon"
                ><lucide-icon name="lock" [size]="16"></lucide-icon
              ></span>
              <div class="toggle-content">
                <span class="toggle-label">Private Match</span>
                <span class="toggle-description"
                  >Only invited players can join</span
                >
              </div>
            </div>
            <div class="toggle-switch">
              <input
                type="checkbox"
                id="private"
                [(ngModel)]="isPrivate"
                class="toggle-input"
              />
              <label for="private" class="toggle-slider"></label>
            </div>
          </div>
        </div>
      </div>

      <div class="players-section">
        <h4 class="setting-title">Players</h4>

        <div *ngIf="matchType === 'single'" class="single-match-layout">
          <div class="player-card current-player">
            <div class="player-avatar">
              <span class="avatar-icon"
                ><lucide-icon name="user" [size]="20"></lucide-icon
              ></span>
            </div>
            <div class="player-info">
              <span class="player-name">You</span>
              <span class="player-username">&#64;{{ currentUsername }}</span>
            </div>
          </div>

          <div class="vs-divider">
            <span class="vs-text">VS</span>
          </div>

          <div class="form-group">
            <div class="input-wrapper">
              <input
                type="text"
                class="form-input"
                placeholder="Opponent username"
                [(ngModel)]="opponentName"
              />
              <span class="input-icon"
                ><lucide-icon name="user" [size]="14"></lucide-icon
              ></span>
            </div>
          </div>
        </div>

        <div *ngIf="matchType === 'double'" class="double-match-layout">
          <div class="teams-row">
            <div class="team-section">
              <div class="team-header">
                <span class="team-icon"
                  ><lucide-icon name="users" [size]="16"></lucide-icon
                ></span>
                <span class="team-label">Team 1</span>
              </div>
              <div class="team-players-row">
                <div class="player-card current-player">
                  <div class="player-avatar">
                    <img
                      *ngIf="
                        currentUser?.profile_image && !currentUser?.imageError
                      "
                      [src]="currentUser.profile_image"
                      [alt]="currentUser?.name || 'User'"
                      class="avatar-image"
                      (error)="handleUserImageError($event)"
                    />
                    <span
                      *ngIf="
                        !currentUser?.profile_image || currentUser?.imageError
                      "
                      class="avatar-icon"
                      ><lucide-icon name="user" [size]="20"></lucide-icon
                    ></span>
                  </div>
                  <div class="player-info">
                    <span class="player-name">You</span>
                    <span class="player-username"
                      >&#64;{{ currentUsername }}</span
                    >
                  </div>
                </div>
                <div class="form-group">
                  <div class="input-wrapper">
                    <input
                      type="text"
                      class="form-input"
                      placeholder="Teammate username"
                      [(ngModel)]="teammateName"
                    />
                    <span class="input-icon"
                      ><lucide-icon name="user" [size]="14"></lucide-icon
                    ></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="team-section">
              <div class="team-header">
                <span class="team-icon"
                  ><lucide-icon name="users" [size]="16"></lucide-icon
                ></span>
                <span class="team-label">Team 2</span>
              </div>
              <div class="team-players-row">
                <div class="form-group">
                  <div class="input-wrapper">
                    <input
                      type="text"
                      class="form-input"
                      placeholder="Opponent 1 username"
                      [(ngModel)]="opponent1Name"
                    />
                    <span class="input-icon"
                      ><lucide-icon name="user" [size]="14"></lucide-icon
                    ></span>
                  </div>
                </div>
                <div class="form-group">
                  <div class="input-wrapper">
                    <input
                      type="text"
                      class="form-input"
                      placeholder="Opponent 2 username"
                      [(ngModel)]="opponent2Name"
                    />
                    <span class="input-icon"
                      ><lucide-icon name="user" [size]="14"></lucide-icon
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="vs-divider">
            <span class="vs-text">VS</span>
          </div>
        </div>
      </div>

      <div class="date-time-section">
        <h4 class="setting-title">Date & Time</h4>
        <div class="date-picker-card">
          <div class="date-icon">
            <lucide-icon name="calendar" [size]="20"></lucide-icon>
          </div>
          <div class="date-content">
            <label class="date-label">Select Date</label>
            <p-calendar
              [(ngModel)]="reservationDate"
              dateFormat="yy-mm-dd"
              [minDate]="minDate"
              (onSelect)="onDateChange()"
              [showIcon]="false"
              placeholder="Choose date"
            ></p-calendar>
          </div>
        </div>

        <div class="time-selection" *ngIf="times.length">
          <h5 class="time-title">Available Times</h5>
          <div class="time-slots">
            <button
              *ngFor="let t of times"
              class="time-slot"
              [class.available]="t.available"
              [class.unavailable]="!t.available"
              [class.selected]="selectedTimes.includes(t.hour)"
              [disabled]="!t.available"
              (click)="selectTime(t.hour)"
            >
              <span class="time-text"
                >{{ t.hour.toString().padStart(2, "0") }}:00</span
              >
            </button>
          </div>
        </div>
      </div>

      <div class="price-summary" *ngIf="selectedTimes.length">
        <div class="price-card">
          <div class="price-icon">
            <lucide-icon name="hash" [size]="20"></lucide-icon>
          </div>
          <div class="price-content">
            <span class="price-label">Total Price</span>
            <span class="price-value">{{ totalPrice }} RSD</span>
          </div>
        </div>
      </div>

      <div class="court-selection" *ngIf="selectedTimes.length">
        <h4 class="setting-title">Select Court</h4>
        <div class="courts-grid-selection">
          <div
            *ngFor="let courtOption of availableCourts"
            class="court-option"
            [class.selected]="
              selectedCourt && selectedCourt.id === courtOption.value.id
            "
            (click)="selectCourt(courtOption.value)"
          >
            <div class="court-option-header">
              <span class="court-option-icon"
                ><lucide-icon name="circle-dot" [size]="16"></lucide-icon
              ></span>
              <span class="court-option-name">{{ courtOption.label }}</span>
            </div>
            <div
              class="court-option-details"
              *ngIf="courtOption.value.court_type !== undefined"
            >
              <span
                class="court-type-badge"
                [class.indoor]="
                  courtOption.value.court_type === 1 ||
                  courtOption.value.court_type === 'Indoor'
                "
                [class.outdoor]="
                  courtOption.value.court_type === 0 ||
                  courtOption.value.court_type === 'Outdoor'
                "
              >
                {{
                  courtOption.value.court_type === 1 ||
                  courtOption.value.court_type === "Indoor"
                    ? "Indoor"
                    : "Outdoor"
                }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="booking-action" *ngIf="selectedCourt">
        <button class="book-button" (click)="bookCourt()">
          <span class="book-icon"
            ><lucide-icon name="circle-dot" [size]="18"></lucide-icon
          ></span>
          <span class="book-text">Book Court</span>
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="custom-modal-overlay"
  *ngIf="clubInfoVisible"
  (click)="closeClubInfo()"
>
  <div class="custom-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">{{ selectedClub?.name }}</h2>
      <button class="modal-close" (click)="closeClubInfo()">
        <span class="close-icon">✕</span>
      </button>
    </div>

    <div class="modal-content" *ngIf="selectedClub">
      <div class="info-section">
        <h4 class="info-title">
          <lucide-icon name="map-pin" [size]="16"></lucide-icon> Address
        </h4>
        <p class="info-text">{{ selectedClub.location }}</p>
      </div>

      <div class="info-section">
        <h4 class="info-title">
          <lucide-icon name="clock" [size]="16"></lucide-icon> Working Hours
        </h4>
        <div class="hours-list">
          <div
            *ngFor="let h of getAllOpeningHours(selectedClub)"
            class="hour-item"
          >
            {{ h }}
          </div>
        </div>
      </div>

      <div
        class="info-section"
        *ngIf="selectedClub.clubOpeningExceptions?.length"
      >
        <h4 class="info-title">
          <lucide-icon name="alert-triangle" [size]="16"></lucide-icon>
          Exceptions
        </h4>
        <div class="exceptions-list">
          <div
            *ngFor="let e of selectedClub.clubOpeningExceptions"
            class="exception-item"
          >
            {{ formatException(e) }}
          </div>
        </div>
      </div>

      <div class="info-section">
        <h4 class="info-title">
          <lucide-icon name="hash" [size]="16"></lucide-icon> Pricing
        </h4>
        <div class="pricing-list">
          <div
            *ngFor="let p of getPricingHoursDisplay(selectedClub)"
            class="price-item"
          >
            {{ p }}
          </div>
        </div>
      </div>

      <div class="info-section" *ngIf="selectedClub.clubPricingBundles?.length">
        <h4 class="info-title">
          <lucide-icon name="hash" [size]="16"></lucide-icon> Bundles
        </h4>
        <div class="bundles-list">
          <div
            *ngFor="let b of getBundleDisplay(selectedClub)"
            class="bundle-item"
          >
            {{ b }}
          </div>
        </div>
      </div>

      <div class="info-section" *ngIf="courts.length">
        <h4 class="info-title">
          <lucide-icon name="circle-dot" [size]="16"></lucide-icon> Courts
        </h4>
        <div class="courts-grid">
          <div *ngFor="let c of courts" class="court-info-card">
            <img
              [src]="c.img_path"
              [alt]="c.name"
              onerror="this.src='../../assets/images/court-placeholder.jpg'"
            />
            <span class="court-name">{{ c.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="custom-modal-overlay"
  *ngIf="showConfirmDialog"
  (click)="cancelBooking()"
>
  <div class="custom-confirm-modal" (click)="$event.stopPropagation()">
    <div class="confirm-header">
      <div class="confirm-icon">
        <img
          class="confirm-logo"
          src="assets/reball/reball logo no bg.png"
          alt="ReBall"
        />
      </div>
      <h3 class="confirm-title">Confirm Booking</h3>
    </div>

    <div class="confirm-content">
      <p class="confirm-message">{{ confirmMessage }}</p>
    </div>

    <div class="confirm-actions">
      <button class="confirm-btn cancel" (click)="cancelBooking()">
        <span class="btn-icon">✕</span>
        <span class="btn-text">Cancel</span>
      </button>
      <button class="confirm-btn confirm" (click)="confirmBooking()">
        <span class="btn-icon">✓</span>
        <span class="btn-text">Confirm</span>
      </button>
    </div>
  </div>
</div>
